<div class="grid justify-content-center">
  <div class="col-12 xl:col-8">
    <div class="grid">
      <div class="col-12">
        @if (authService.userHasRoleInList(['USER', 'SUPER-ADMIN',])) {
          <db-latest-transactions></db-latest-transactions>
        }
        @if (authService.userHasRole('LEAD')) {
          <db-business-partner></db-business-partner>
        }
      </div>
      <!-- mockup-view -> disabled
      @if (authService.userHasRoleInList(['USER', 'SUPER-ADMIN',])) {
        <div class="col-12">
          <db-latest-invoice></db-latest-invoice>
        </div>
      }
      -->
    </div>
  </div>
  <div class="col-12 xl:col-4">
    <div class="grid">
      <div class="col-12 xl:col-12 lg:col-6">
        @if (authService.userHasRoleInList(['USER', 'SUPER-ADMIN',])) {
          <db-payment-methods></db-payment-methods>
        }
        @if (authService.userHasRole('LEAD')) {
          <db-add-business-partner></db-add-business-partner>
        }
      </div>
      <div class="col-12 xl:col-12 lg:col-6">
        <sps-support-info></sps-support-info>
      </div>
    </div>
  </div>
</div>

